$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.el-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});


$(document).on("click", "a[href='#shop']", function (e) {
  e.preventDefault();
  document.querySelector('#shop').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});






$(document).on("click", ".el-element-sub-option", function(e) {
$(this).parents('.el-product').find('.el-element-sub-option').removeClass('el-active');
$(this).addClass('el-active');
var sub_tab = $(this).attr('sub_tab');
$(this).parents('.el-product').find('.el-sub-trigger').hide().removeClass('el-active');
$(this).parents('.el-product').find('.el-sub-trigger[sub_tab="'+sub_tab+'"]').show().addClass('el-active');
var selling_plan = $('.el-sub-delivery-options.el-active .el-delivery-option.el-active').attr('selling_plan');
if(sub_tab=='1'){
$(this).parents('.el-product').find('.el-checkout-button').attr('selling_plan',selling_plan);
} else {
$(this).parents('.el-product').find('.el-checkout-button').removeAttr('selling_plan');
}
});


$(document).on("click", ".el-delivery-option", function(e) {
$(this).parents('.el-sub-delivery-options').find('.el-delivery-option').removeClass('el-active');
$(this).addClass('el-active');
var selling_plan = $(this).attr('selling_plan');
$(this).parents('.el-product').find('.el-checkout-button').attr('selling_plan',selling_plan);
});




$(document).on("click", ".el-element-variant", function(e) {
$(this).parents('.el-product').find('.el-element-variant').removeClass('el-active');
$(this).addClass('el-active');
var variant_id = $(this).attr('variant_id');
$(this).parents('.el-product').find('.el-variant-trigger').hide().removeClass('el-active');
$(this).parents('.el-product').find('.el-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('el-active');
$(this).parents('.el-product').find('.el-checkout-button').attr('variant_id',variant_id);
});

$(document).on("click", ".el-element-option", function(e) {
$(this).parents('.el-product').find('.el-element-option').removeClass('el-active');
$(this).addClass('el-active');
var quantity = $(this).attr('quantity');
$(this).parents('.el-product').find('.el-quantity-trigger').hide().removeClass('el-active');
$(this).parents('.el-product').find('.el-quantity-trigger[quantity="'+quantity+'"]').show().addClass('el-active');
$(this).parents('.el-product').find('.el-checkout-button').attr('quantity',quantity);
if (quantity == "1") {
$('.el-sub-delivery-options').removeClass('el-active').hide();
$('.el-sub-delivery-options.el-sub-delivery-options-less').addClass('el-active').show();
var sub_tab = $('.el-element-sub-option.el-active').attr('sub_tab');
if(sub_tab=='1'){
var selling_plan = $('.el-sub-delivery-options.el-active .el-delivery-option.el-active').attr('selling_plan');
$(this).parents('.el-product').find('.el-checkout-button').attr('selling_plan',selling_plan);
} else {
$(this).parents('.el-product').find('.el-checkout-button').removeAttr('selling_plan');
}
} else {
$('.el-sub-delivery-options').removeClass('el-active').hide();
$('.el-sub-delivery-options.el-sub-delivery-options-more').addClass('el-active').show();
var sub_tab = $('.el-element-sub-option.el-active').attr('sub_tab');
if(sub_tab=='1'){
var selling_plan = $('.el-sub-delivery-options.el-active .el-delivery-option.el-active').attr('selling_plan');
$(this).parents('.el-product').find('.el-checkout-button').attr('selling_plan',selling_plan);
} else {
$(this).parents('.el-product').find('.el-checkout-button').removeAttr('selling_plan');
}
}
});










$(document).on("click", ".el-cart-button", function (e) {
  e.preventDefault();
  $('#cart-drawer').addClass('open');
  $('.custom_overlay2').addClass('active');
});







$(document).on("click", "a[href='#more']", function (e) {
  e.preventDefault();
 $('.el-pdp-review-list1-item:nth-child(3)~.el-pdp-review-list1-item').slideDown();
 $('.el-pdp-review-links:has(a[href="#more"])').hide();
 $('.el-pdp-review-links:has(a[href="#less"])').show();
});



$(document).on("click", "a[href='#less']", function (e) {
  e.preventDefault();
 $('.el-pdp-review-list1-item:nth-child(3)~.el-pdp-review-list1-item').slideUp();
 $('.el-pdp-review-links:has(a[href="#less"])').hide();
 $('.el-pdp-review-links:has(a[href="#more"])').show();
});



$(document).on("click", ".el-pdp-like-list1-item .el-media.el-svg", function (e) {
  if (jQuery(this).hasClass("el-active")) {
    jQuery(this).toggleClass('el-active');
    jQuery(this).parents('.el-pdp-like-list1-item').find('.el-element-texts, .el-element-image .el-media.el-hide-desktop').slideToggle();
  } else {
    jQuery('.el-pdp-like-list1-item .el-media.el-svg').removeClass('el-active');
    jQuery('.el-pdp-like-list1-item .el-media.el-svg').parents('.el-pdp-like-list1-item').find('.el-element-texts, .el-element-image .el-media.el-hide-desktop').slideUp();
    jQuery(this).toggleClass('el-active');
    jQuery(this).parents('.el-pdp-like-list1-item').find('.el-element-texts, .el-element-image .el-media.el-hide-desktop').slideToggle();
  }
});




$(document).on("click", ".el-pdp-pdt-small-heading p:nth-child(2)", function (e) {
  e.preventDefault();
 $('.el-popup').addClass('el-active');
});



$(document).on("click", "a[href='#close']", function (e) {
  e.preventDefault();
 $('.el-popup').removeClass('el-active');
});





function initFaqSlider() {
    $('.el-pdp-pdt-faq1 .el-answer ul.slick-slider').each(function() {
    $(this).slick('unslick');
    });
    $('.el-pdp-pdt-faq1 .el-answer ul').each(function() {
            $(this).slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                adaptiveHeight: false,
                responsive: [
                {
                breakpoint: 915,
                settings: {
                slidesToShow: 1,
                 }
                }
                ]
            });
    });
}

$(document).on("click", ".el-pdp-pdt-faq1 .el-question", function (e) {
                 setTimeout(function () {
  initFaqSlider();
                 }, 100);
                 setTimeout(function () {
  initFaqSlider();
                 }, 500);
});





function initFaqSlider2() {
    $('.el-pdp-pdt-faq2 .el-answer ul.slick-slider').each(function() {
    $(this).slick('unslick');
    });
    $('.el-pdp-pdt-faq2 .el-answer ul').each(function() {
            $(this).slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                adaptiveHeight: false
            });
    });
}

$(document).on("click", ".el-pdp-pdt-faq2 .el-question", function (e) {
                 setTimeout(function () {
  initFaqSlider2();
                 }, 100);
                 setTimeout(function () {
  initFaqSlider2();
                 }, 500);
});



  $(document).on("click", '.el-atc-js', function (e) {
  e.preventDefault();

  var $btn = $(this);

  // prevent multiple clicks
  if ($btn.hasClass('el-loading')) return;

  $btn.addClass('el-loading');

  var items = [];

  // main product
  var variant_id = $btn.attr('variant_id');
  var selling_plan = $btn.attr('selling_plan');
  var quantity = $btn.attr('quantity');

  var item = {
    id: parseInt(variant_id),
    quantity: quantity
  };

  // add selling plan if exists
  if (selling_plan) {
    item.selling_plan = parseInt(selling_plan);
  }

  items.push(item);



  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {

    },

    complete: function () {
        refreshCartDrawer();
      setTimeout(function () {
    $("#cart-drawer").removeClass("is_empty").addClass("open");
        $btn.removeClass('el-loading');
      }, 500);
    }
  });

});





$(document).on("click", ".el-hp-every-item", function (e) {
  e.preventDefault();
 $('.el-hp-every-item').removeClass('el-active');
 $(this).addClass('el-active');
});

$(document).on("click", ".el-hp-every-item1", function (e) {
  e.preventDefault();
 $('.slick-slide:has(.el-hp-every-slide)').show();
});

$(document).on("click", ".el-hp-every-item2", function (e) {
  e.preventDefault();
 $('.slick-slide:has(.el-hp-every-slide)').hide();
 $('.slick-slide:has(.el-hp-every-slide1)').show();
});

$(document).on("click", ".el-hp-every-item3", function (e) {
  e.preventDefault();
 $('.slick-slide:has(.el-hp-every-slide)').hide();
 $('.slick-slide:has(.el-hp-every-slide2)').show();
});
